import { Link } from "@tanstack/react-router";
import { useEffect } from "react";

const NotFound = () => {
  useEffect(() => {
    // Redirect to the error page
    if (import.meta.env.DEV) {
      return;
    }

    window.location.href = "https://bulletin.nexon.com/nxk/error.html?error=404";
  }, []);

  if (import.meta.env.PROD) {
    return null;
  }
  return (
    <div className="flex flex-col items-center space-y-2">
      <h1 className="text-xl">Not Found</h1>
      <Link to="/login" className="text-blue-600">
        👉go to login
      </Link>
      <Link to="/loginblock" className="text-blue-600">
        👉go to loginblock
      </Link>
    </div>
  );
};

export default NotFound;
